import eventBus from "infrastructure/common/eventBus";
import {ModalEvents} from "presentation/common/components/style-guide/modal/ModalEvents";
import {
  BillIssuerNotMatchMessageContent,
  CancelledPaymentMessageContent,
  ConfirmMessageContent,
  ErrorMessageContent,
  InfoMessageContent,
  InvalidBillTypeMessageContent,
  MessageSentContent,
  SuccessMessageContent
} from "presentation/common/components/style-guide/modal";

export const models = {
  state: {},
  reducers: {},
  effects: (dispatch) => ({
    showBillIssuerNotMatchMessage: function (props) {
      return eventBus.dispatch(ModalEvents.OPEN, {
        content: BillIssuerNotMatchMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        ...props,
      });
    },
    showErrorMessage: function (props = {}) {
      eventBus.dispatch(ModalEvents.OPEN, {
        content: ErrorMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        ...props,
      });
    },
    showSendEmailMessage: function (email) {
      return eventBus.dispatch(ModalEvents.OPEN, {
        content: MessageSentContent,
        className: 'modal-info-type',
        target: email,
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE)
      });
    },
    showInvalidBillTypeMessage: function (props = {}) {
      return eventBus.dispatch(ModalEvents.OPEN, {
        content: InvalidBillTypeMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        ...props
      });
    },
    showInvalidOwnerMessage: function (props = {}) {
      return eventBus.dispatch(ModalEvents.OPEN, {
        content: InvalidBillTypeMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        message: 'Los datos insertados del propietario no se corresponden con la factura adjuntada.',
        title: '¡Ajuste información!'
      });
    },
    showInfoMessage: function (props) {
      return eventBus.dispatch(ModalEvents.OPEN, {
        content: InfoMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        ...props,
      });
    },
    showCancelledPaymentMessage: function (props) {
      return eventBus.dispatch(ModalEvents.OPEN, {
        content: CancelledPaymentMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        ...props
      });
    },
    showSuccessMessage: function (props = {}) {
      eventBus.dispatch(ModalEvents.OPEN, {
        content: SuccessMessageContent,
        className: 'modal-info-type',
        onClose: () => eventBus.dispatch(ModalEvents.CLOSE),
        ...props,
      });
    },
    showConfirmMessage: function ({onClose, onConfirm, ...rest} = {}) {
      eventBus.dispatch(ModalEvents.OPEN, {
        content: ConfirmMessageContent,
        className: 'modal-info-type',
        onClose: () => {
          eventBus.dispatch(ModalEvents.CLOSE);
          onClose && onClose();
        },
        onConfirm: () => {
          eventBus.dispatch(ModalEvents.CLOSE);
          onConfirm && onConfirm();
        },
        ...rest
      });
    },
    showIncompleteProfileMessage: function({onClose}) {
      eventBus.dispatch(ModalEvents.OPEN, {
        content: InvalidBillTypeMessageContent,
        className: 'modal-info-type',
        onClose: () => {
          eventBus.dispatch(ModalEvents.CLOSE);
          onClose && onClose();
        },
        message: 'Debe completar los datos del perfil para acceder a los documentos.',
        title: '¡Actualizar Datos Del Perfil!'
      });
    }
  }),
  selectors: (slice, createSelector, hasProps) => ({}),
};

